// import React, { useEffect, useState } from "react";
// import axios from "axios";

// export default function PolicyHomePage() {
//   const [policies, setPolicies] = useState([]);
//   const [activeTab, setActiveTab] = useState("");
//   const [policyData, setPolicyData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [tabsLoading, setTabsLoading] = useState(false);

//   // Base URL
//   const BASE_URL = "YOUR_API_BASE_URL";

//   // Get all policy tabs
//   const fetchPolicies = async () => {
//     try {
//       setTabsLoading(true);

//       const response = await axios.get(`${BASE_URL}/policies`);

//       if (response?.data?.success) {
//         const policyList = response.data.data.policies;

//         setPolicies(policyList);

//         // Default first tab select
//         if (policyList.length > 0) {
//           setActiveTab(policyList[0].key);
//           fetchPolicyDetails(policyList[0].key);
//         }
//       }
//     } catch (error) {
//       console.log("Policies Error:", error);
//     } finally {
//       setTabsLoading(false);
//     }
//   };

//   // Get single policy data
//   const fetchPolicyDetails = async (key) => {
//     try {
//       setLoading(true);

//       const response = await axios.get(`${BASE_URL}/policies/${key}`);

//       if (response?.data?.success) {
//         setPolicyData(response.data.data.policy);
//       }
//     } catch (error) {
//       console.log("Policy Details Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPolicies();
//   }, []);

//   const handleTabClick = (key) => {
//     setActiveTab(key);
//     fetchPolicyDetails(key);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-6">
//       <div className="max-w-6xl mx-auto">
//         {/* Heading */}
//         <div className="mb-6">
//           <h1 className="text-3xl font-bold text-gray-900">
//             Policies & Information
//           </h1>
//           <p className="text-gray-500 mt-1">
//             Read all important policies and guidelines.
//           </p>
//         </div>

//         {/* Tabs */}
//         <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-3 mb-6 overflow-x-auto">
//           <div className="flex gap-3 min-w-max">
//             {tabsLoading ? (
//               <>
//                 {[1, 2, 3, 4].map((item) => (
//                   <div
//                     key={item}
//                     className="h-11 w-36 rounded-xl bg-gray-200 animate-pulse"
//                   />
//                 ))}
//               </>
//             ) : (
//               policies.map((item) => (
//                 <button
//                   key={item.id}
//                   onClick={() => handleTabClick(item.key)}
//                   className={`px-5 py-3 rounded-xl text-sm font-semibold transition-all duration-200 whitespace-nowrap ${
//                     activeTab === item.key
//                       ? "bg-black text-white shadow-md"
//                       : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                   }`}
//                 >
//                   {item.title}
//                 </button>
//               ))
//             )}
//           </div>
//         </div>

//         {/* Content */}
//         <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 md:p-8">
//           {loading ? (
//             <div className="space-y-4">
//               <div className="h-8 w-60 bg-gray-200 rounded animate-pulse" />
//               <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
//               <div className="h-4 w-full bg-gray-200 rounded animate-pulse" />
//               <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse" />
//             </div>
//           ) : policyData ? (
//             <>
//               <h2 className="text-2xl font-bold text-gray-900 mb-5">
//                 {policyData.title}
//               </h2>

//               <div className="text-gray-700 leading-8 text-base whitespace-pre-line">
//                 {policyData.content}
//               </div>

//               <div className="mt-8 pt-5 border-t border-gray-100 text-sm text-gray-400">
//                 Last Updated: {policyData.updated_at}
//               </div>
//             </>
//           ) : (
//             <div className="text-center py-16 text-gray-500">
//               No Policy Found
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }


// pages/PolicyHomePage.jsx

import React, { useEffect, useState } from "react";
import { policyService } from "../../services/api";
import toast from "react-hot-toast";

export default function PolicyHomePage() {
  const [policies, setPolicies] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [policyData, setPolicyData] = useState(null);

  const [tabsLoading, setTabsLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [editTitle, setEditTitle] = useState("");
  const [editContent, setEditContent] = useState("");
  const [updating, setUpdating] = useState(false);

  /* ─────────────────────────────────────
     Get All Policies
  ───────────────────────────────────── */

  const fetchPolicies = async () => {
    try {
      setTabsLoading(true);

      const res = await policyService.getAllPolicies();

      setPolicies(res);

      // first tab auto open
      if (res?.length > 0) {
        setActiveTab(res[0].key);
        fetchPolicyContent(res[0].key);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTabsLoading(false);
    }
  };

  /* ─────────────────────────────────────
     Get Single Policy Content
  ───────────────────────────────────── */

  const fetchPolicyContent = async (key) => {
    try {
      setContentLoading(true);

      const res = await policyService.getPolicyByKey(key);

      setPolicyData(res);
    } catch (error) {
      console.log(error);
    } finally {
      setContentLoading(false);
    }
  };

const handleEdit = () => {
  setEditMode(true);

  setEditTitle(policyData?.title || "");

  // contact us special handling
  if (policyData?.key === "contact_us") {
    setEditContent(policyData?.content || "");
  } else {
    setEditContent(
      typeof policyData?.content === "string"
        ? policyData?.content
        : JSON.stringify(policyData?.content, null, 2),
    );
  }
};

const handleUpdatePolicy = async () => {
  try {
    setUpdating(true);

    let finalContent = editContent;

    // Contact Us special object payload
    if (policyData?.key === "contact_us") {
    finalContent = editContent;
    } else {
      // Other policies
      try {
        finalContent = JSON.parse(editContent);
      } catch (e) {}
    }

    await policyService.updatePolicy(policyData.key, {
      title: editTitle,
      content: finalContent,
    });

    setPolicyData({
      ...policyData,
      title: editTitle,
      content: finalContent,
    });

    setEditMode(false);

    toast.success("Policy updated successfully!");
  } catch (error) {
    console.log(error);

    toast.error(error?.response?.data?.message || "Failed to update policy");
  } finally {
    setUpdating(false);
  }
};

  useEffect(() => {
    fetchPolicies();
  }, []);

  const handleTabClick = (key) => {
    setActiveTab(key);
    fetchPolicyContent(key);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">
            Policies & Information
          </h1>

          <p className="text-gray-500 mt-2">
            Read all important policies and guidelines.
          </p>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-3 mb-6 overflow-x-auto hide-scrollbar">
          <div className="flex gap-3 min-w-max">
            {tabsLoading
              ? [1, 2, 3, 4].map((item) => (
                  <div
                    key={item}
                    className="h-11 w-36 rounded-xl bg-gray-200 animate-pulse"
                  />
                ))
              : policies.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => handleTabClick(item.key)}
                    className={`px-5 py-3 rounded-xl text-sm font-semibold transition-all duration-200 whitespace-nowrap ${
                      activeTab === item.key
                        ? "bg-black text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    {item.title}
                  </button>
                ))}
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6 md:p-8">
          {contentLoading ? (
            <div className="space-y-4">
              <div className="h-8 w-60 rounded bg-gray-200 animate-pulse" />
              <div className="h-4 w-full rounded bg-gray-200 animate-pulse" />
              <div className="h-4 w-full rounded bg-gray-200 animate-pulse" />
              <div className="h-4 w-3/4 rounded bg-gray-200 animate-pulse" />
            </div>
          ) : policyData ? (
            <>
              {/* Header */}
              <div className="flex items-center justify-between gap-4 mb-6">
                {editMode ? (
                  <input
                    type="text"
                    value={editTitle}
                    onChange={(e) => setEditTitle(e.target.value)}
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-black"
                  />
                ) : (
                  <h2 className="text-2xl font-bold text-gray-900">
                    {policyData.title}
                  </h2>
                )}

                {!editMode ? (
                  <button
                    onClick={handleEdit}
                    className="px-5 py-2.5 rounded-xl bg-black text-white text-sm font-medium"
                  >
                    Edit
                  </button>
                ) : (
                  <div className="flex gap-3">
                    <button
                      onClick={() => setEditMode(false)}
                      className="px-5 py-2.5 rounded-xl border border-gray-300 text-sm font-medium"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={handleUpdatePolicy}
                      disabled={updating}
                      className="px-5 py-2.5 rounded-xl bg-black text-white text-sm font-medium"
                    >
                      {updating ? "Updating..." : "Save"}
                    </button>
                  </div>
                )}
              </div>

              {/* Content */}
              {editMode ? (
                policyData?.key === "contact_us" ? (
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">
                      Phone Number
                    </label>

                    <input
                      type="text"
                      value={editContent}
                      onChange={(e) => setEditContent(e.target.value)}
                      placeholder="Enter phone number"
                      className="w-full border border-gray-300 rounded-2xl p-4 outline-none focus:ring-2 focus:ring-black"
                    />
                  </div>
                ) : (
                  <textarea
                    rows={12}
                    value={editContent}
                    onChange={(e) => setEditContent(e.target.value)}
                    className="w-full border border-gray-300 rounded-2xl p-4 outline-none focus:ring-2 focus:ring-black"
                  />
                )
              ) : (
                <div className="text-gray-700 leading-8 whitespace-pre-line">
                  {typeof policyData.content === "object" &&
                  policyData.content !== null ? (
                    <div className="space-y-3">
                      {Object.entries(policyData.content).map(
                        ([key, value]) => (
                          <div
                            key={key}
                            className="flex items-center gap-2 bg-gray-50 border border-gray-100 rounded-xl p-4"
                          >
                            <span className="font-semibold capitalize text-gray-900">
                              {key.replace("_", " ")} :
                            </span>

                            <span className="text-gray-700">{value}</span>
                          </div>
                        ),
                      )}
                    </div>
                  ) : (
                    <span>{policyData.content}</span>
                  )}
                </div>
              )}

              <div className="mt-8 pt-4 border-t border-gray-100 text-sm text-gray-400">
                Last Updated : {policyData.updated_at}
              </div>
            </>
          ) : (
            <div className="text-center py-16 text-gray-500">
              No Policy Found
            </div>
          )}
        </div>
      </div>
    </div>
  );
}